import React from 'react';
import { Modal, Spin } from 'antd';
import s from './s.module.less';

import useKanmonConnect from 'hooks/useKanmonConnect';
import { getKanmonUiView } from 'utils/kanmonUi';
import commonS from 'styles/common.module.less';
import FinancialsLandingPage from 'pages/dashboard/FinancialsPage/components/FinancialsLandingPage';
import {
    getHasAutoPopInvoicePaybackTermModal,
    setHasAutoPopInvoicePaybackTermModal,
    getHasClosePayLaterTipsInFinancials,
    setHasClosePayLaterTipsInFinancials,
} from 'utils/localstore';
import PaybackTermModal from 'pages/dashboard/FinancialsPage/components/PaybackTermModal';
import useKanmonProducts from 'hooks/useKanmonProducts';

//https://www.figma.com/design/w4vpLJZeMLx9XzMg0c71Dm/Financial---Settings?node-id=8104-79126&m=dev
//a. User has not applied Klarity Pay Later yet
//b. User's application is being processed
//c. User’s application is under review
//d. After the user’s application is approved
//e. If a user has clicked ‘View your offers’ & and opened the modal
//f. If the user’s application is declined

const PayLaterTips = () => {
    const [autoShowKanmonModal, setAutoShowKanmonModal] = React.useState(false);
    const [showPaylaterModal, setShowPaylaterModal] = React.useState(false);
    const [showPaybackTermModal, setShowPaybackTermModal] = React.useState(false);
    const [products, loadingProducts, , productsError] = useKanmonProducts();
    const [kanmonConnect, kanmonInfo, loadingKanmonConnect, refetchKanmonInfo, ui] = useKanmonConnect();
    const productsStatus = productsError ? 'error' : 'ready';
    const view = getKanmonUiView(ui, !!kanmonInfo?.kanmonBusinessId, products, loadingProducts ? 'loading' : productsStatus);
    const [isClosed, setIsClosed] = React.useState(getHasClosePayLaterTipsInFinancials());

    React.useEffect(() => {
        if (autoShowKanmonModal && kanmonConnect) {
            setAutoShowKanmonModal(false);
            setShowPaylaterModal(false);
            kanmonConnect.show();
        }
    }, [autoShowKanmonModal, kanmonConnect]);

    React.useEffect(() => {
        if (view.canSelectPayLater && products.length > 0) {
            const hasAutoPopInvoicePaybackTermModal = getHasAutoPopInvoicePaybackTermModal();
            if (!hasAutoPopInvoicePaybackTermModal) {
                setShowPaybackTermModal(true);
                setHasAutoPopInvoicePaybackTermModal(true);
            }
        }
    }, [view.canSelectPayLater, products]);

    if (isClosed) {
        return null;
    }

    if (loadingKanmonConnect && !kanmonInfo) {
        return (
            <div className={s.loading}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div className={s.wrap}>
            <div className={s.tipsWrap}>
                <div className={s.title}>{view.detailText}</div>
                <div className={s.view}>
                    <span
                        className={s.viewBtn}
                        onClick={() => {
                            if (view.primaryAction === 'apply') {
                                setShowPaylaterModal(true);
                            } else if (view.primaryAction === 'retry' || !kanmonConnect) {
                                refetchKanmonInfo();
                            } else {
                                kanmonConnect.show();
                            }
                        }}
                    >
                        {view.ctaText} →
                    </span>
                    <span
                        className={s.viewClose}
                        onClick={() => {
                            setIsClosed(true);
                            setHasClosePayLaterTipsInFinancials(true);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
                                fill="#1D4ED8"
                            />
                        </svg>
                    </span>
                </div>
            </div>
            <Modal
                width="90%"
                open={showPaylaterModal}
                className={`${commonS.modalFixHeightWrap} ${s.modalWrap}`}
                title="Grow your practice faster with Klarity Pay Later (Powered by Kanmon)"
                onCancel={() => {
                    setShowPaylaterModal(false);
                }}
                footer={null}
                destroyOnClose
            >
                <div className={s.modalWrap}>
                    <FinancialsLandingPage
                        onClickedApplyNow={() => {
                            refetchKanmonInfo();
                            setAutoShowKanmonModal(true);
                        }}
                        doShowKanmonModal={() => {
                            setShowPaylaterModal(false);
                            if (kanmonConnect) {
                                kanmonConnect.show();
                            } else {
                                refetchKanmonInfo();
                            }
                        }}
                        isModal
                    />
                </div>
            </Modal>
            <PaybackTermModal
                open={showPaybackTermModal}
                onCancel={() => setShowPaybackTermModal(false)}
                onSuccess={() => {
                    setShowPaybackTermModal(false);
                }}
            />
        </div>
    );
};

export default PayLaterTips;
